export const termsEn = `
## Terms and Conditions
Welcome to Wiser. Our service provides
personalized mental wellness support through an advanced chatbot, leveraging AI
technology to offer insights and conversations based on your personal profile,
which includes your personality test results and life experiences.

By accessing and using our services, you agree to comply with and be bound by
the following terms and conditions. Please review them carefully. If you do not
agree to these terms, you must not use our services.

## Eligibility
You must be at least 18 years old to use our services, or the legal age of
majority in your jurisdiction, whichever is higher. By using our services, you
represent and warrant that you meet these eligibility requirements.

## Privacy and Data Protection
Your privacy is critically important to us. Our Privacy Policy, which is part of
these Terms and Conditions, outlines how we collect, use, store, and protect
your personal information, including the details you provide during the intake
process and any information generated through your use of our chatbot.

## User Accounts and Responsibilities
- **Account Creation**: To access certain features of our service, you may need
  to create an account. You agree to provide accurate, current, and complete
  information during the registration process and to update such information to
  keep it accurate, current, and complete.
- **Account Security**: You are responsible for safeguarding your account
  password and for any activities or actions under your account. We encourage
  you to use "strong" passwords (passwords that use a combination of upper and
  lower case letters, numbers, and symbols) with your account.

## Services and Coins
- **Free and Paid Services**: Our service operates on a coin-based system where
  initial conversations are free, and subsequent conversations require payment
  in the form of coins.
- **Purchases**: Additional coins can be purchased through our website or
  application. All purchases are final and non-refundable, except as required by
  law.
- **Usage**: Coins are for personal use only and are not transferable or
  sellable.

## Disclaimers
Our chatbot is designed to provide support and insights based on the information
you provide. It is not a substitute for professional medical advice, diagnosis,
or treatment. Always seek the advice of your physician or other qualified health
providers with any questions you may have regarding a medical condition.

## Limitation of Liability
We are not liable for any indirect, incidental, special, consequential, or
punitive damages, including without limitation, loss of profits, data, use,
goodwill, or other intangible losses, resulting from (i) your access to or use
of or inability to access or use the service; (ii) any conduct or content of any
third party on the service; (iii) any content obtained from the service; and
(iv) unauthorized access, use, or alteration of your transmissions or content,
whether based on warranty, contract, tort (including negligence) or any other
legal theory, whether or not we have been informed of the possibility of such
damage.

## Changes to Terms and Conditions
We reserve the right, at our sole discretion, to modify or replace these Terms
at any time. If a revision is material, we will provide at least 30 days' notice
before any new terms take effect. What constitutes a material change will be
determined at our sole discretion.

## Governing Law
These Terms shall be governed and construed in accordance with the laws of the Netherlands, without regard to its conflict of law provisions.

## Contact Us
If you have any questions about these Terms, please contact us through our contact form.
`

export const termsNl = `
## Algemene Voorwaarden
Welkom bij Wiser. Onze dienst biedt
gepersonaliseerde ondersteuning voor mentaal welzijn door middel van een geavanceerde chatbot, die AI-technologie gebruikt om inzichten en gesprekken te bieden op basis van uw persoonlijk profiel,
dat uw resultaten van persoonlijkheidstesten en levenservaringen omvat.

Door toegang te krijgen tot en gebruik te maken van onze diensten, gaat u akkoord met de naleving van en gebondenheid aan
de volgende algemene voorwaarden. Lees ze zorgvuldig door. Als u niet akkoord gaat met deze voorwaarden, mag u onze diensten niet gebruiken.

## Geschiktheid
U moet minstens 18 jaar oud zijn om onze diensten te gebruiken, of de wettelijke meerderjarigheidsleeftijd in uw rechtsgebied,
afhankelijk van wat hoger is. Door onze diensten te gebruiken, verklaart en garandeert u dat u aan deze geschiktheidseisen voldoet.

## Privacy en Gegevensbescherming
Uw privacy is van cruciaal belang voor ons. Ons Privacybeleid, dat deel uitmaakt van
deze Algemene Voorwaarden, schetst hoe we uw persoonlijke informatie verzamelen, gebruiken, opslaan en beschermen,
inclusief de gegevens die u verstrekt tijdens het intakeproces en alle informatie die wordt gegenereerd door uw gebruik van onze chatbot.

## Gebruikersaccounts en Verantwoordelijkheden
- **Accountaanmaak**: Om toegang te krijgen tot bepaalde functies van onze dienst, moet u
  mogelijk een account aanmaken. U stemt ermee in om nauwkeurige, actuele en volledige
  informatie te verstrekken tijdens het registratieproces en dergelijke informatie bij te werken om deze nauwkeurig, actueel en compleet te houden.
- **Accountbeveiliging**: U bent verantwoordelijk voor het beveiligen van uw accountwachtwoord en voor alle activiteiten of acties onder uw account. We moedigen u aan om "sterke" wachtwoorden te gebruiken (wachtwoorden die een combinatie van hoofdletters en kleine letters, cijfers en symbolen gebruiken) met uw account.

## Diensten en Munten
- **Gratis en Betaalde Diensten**: Onze dienst werkt op een muntgebaseerd systeem waarbij
  initiële gesprekken gratis zijn, en volgende gesprekken betaling in de vorm van munten vereisen.
- **Aankopen**: Extra munten kunnen worden gekocht via onze website of
  applicatie. Alle aankopen zijn definitief en niet-restitueerbaar, behalve zoals vereist door
  wetgeving.
- **Gebruik**: Munten zijn alleen voor persoonlijk gebruik en zijn niet overdraagbaar of
  verkoopbaar.

## Disclaimers
Onze chatbot is ontworpen om ondersteuning en inzichten te bieden op basis van de informatie
die u verstrekt. Het is geen vervanging voor professioneel medisch advies, diagnose,
of behandeling. Zoek altijd het advies van uw arts of een andere gekwalificeerde gezondheidsaanbieder met eventuele vragen die u heeft over een medische aandoening.

## Beperking van Aansprakelijkheid
Wij zijn niet aansprakelijk voor enige indirecte, incidentele, bijzondere, gevolgschade of
strafschade, inclusief zonder beperking, verlies van winsten, gegevens, gebruik,
goodwill, of andere immateriële verliezen, voortvloeiend uit (i) uw toegang tot of gebruik van of onvermogen om toegang te krijgen tot of gebruik te maken van de dienst; (ii) enig gedrag of inhoud van een derde partij op de dienst; (iii) enige inhoud verkregen van de dienst; en
(iv) onbevoegde toegang, gebruik of wijziging van uw transmissies of inhoud,
op basis van garantie, contract, onrechtmatige daad (inclusief nalatigheid) of enige andere
juridische theorie, ongeacht of we al dan niet zijn geïnformeerd over de mogelijkheid van dergelijke schade.

## Wijzigingen in Algemene Voorwaarden
Wij behouden ons het recht voor om deze Voorwaarden op elk moment naar eigen goeddunken te wijzigen of te vervangen. Als een wijziging materieel is, zullen we ten minste 30 dagen van tevoren kennisgeven voordat de nieuwe voorwaarden van kracht worden. Wat een materiële verandering is, wordt naar ons eigen goeddunken bepaald.

## Toepasselijk Recht
Deze Voorwaarden zullen worden beheerst en geïnterpreteerd in overeenstemming met de wetten van Nederland, zonder rekening te houden met de bepalingen inzake conflicten van wetten.

## Contacteer Ons
Als u vragen heeft over deze Voorwaarden, neem dan contact met ons op via ons contactformulier.
`
